import { useQuery } from "@tanstack/react-query";
import {
	EventRatingsFilters,
	EventRatingsResponse,
	reportsService,
} from "../../services/reports.service";

const useEventRatingsReport = (filters: EventRatingsFilters) => {
	const enabled = Boolean(filters.accountId && filters.programId);

	return useQuery<EventRatingsResponse>({
		queryKey: [
			"reports-event-ratings",
			filters.accountId,
			filters.programId,
			filters.eventId ?? "",
			filters.enrollmentId ?? "",
			filters.startDate ?? "",
			filters.endDate ?? "",
		],
		queryFn: () => reportsService.getEventRatings(filters),
		enabled,
		staleTime: 1000 * 60 * 5,
	});
};

export default useEventRatingsReport;
